<div class="transfer-assignment">
  <div class="cards">
    <div class="card">
      <div class="form-group">
        <select class="form-control" (change)="changeFieldGroup($event)" id="selectAssignment">
          <option value="" selected>Select Assignment Type</option>
          <option *ngFor="let group of assignmentGroups" [value]="group">{{ group }}</option>
        </select>
      </div>
      <div class="field-groups">
        <!-- Assigned to Job -->
        <div *ngIf="assignmentGroup === assignmentGroupsType.AssignedToJob" class="field-group">
          <div class="row">
            <div class="col-12 col-lg-6">
              <label> Job </label>
              <app-tool-transfer-autocomplete-search
                id="jobId"
                model="jobs"
                (filter)="fillJobsData($event)"
                dropdownType="jobs"
                #jobsAutocomplete></app-tool-transfer-autocomplete-search>
            </div>
            <div class="col-12 col-lg-6">
              <label> Owner </label>
              <app-tool-transfer-autocomplete-search
                model="owners"
                [inputItems]="transferDropDown.owners"
                [pagination]="paginationData.owners"
                bindLabel="ownerName"
                id="ownerId"
                dropdownType="single"
                #ownersAutocomplete
                (filter)="fillJobsData($event)">
              </app-tool-transfer-autocomplete-search>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <label> Facility (optional) </label>
              <app-tool-transfer-autocomplete-search
                model="facilities"
                [inputItems]="transferDropDown.facilities"
                [pagination]="paginationData.facilities"
                bindLabel="facilityName"
                id="facilityId"
                dropdownType="single"
                #facilitiesAutocomplete
                [refreshOnClose]="false"
                (filter)="fillJobsData($event)"></app-tool-transfer-autocomplete-search>
            </div>
            <div class="col-12 col-lg-6">
              <label> Responsible Party (optional) </label>
              <app-tool-transfer-autocomplete-search
                model="users"
                [inputItems]="transferDropDown.users"
                [pagination]="paginationData.users"
                bindLabel="employeeAlias"
                id="responsiblePartyId"
                label="Responsible Party"
                dropdownType="single"
                #usersAutocomplete
                (filter)="fillJobsData($event)">
              </app-tool-transfer-autocomplete-search>
            </div>
          </div>
        </div>

        <!-- Assigned to Employee -->
        <div *ngIf="assignmentGroup === assignmentGroupsType.AssignedToEmployee" class="field-group">
          <div class="row">
            <div class="col-12">
              <label> Employee </label>
              <app-tool-transfer-autocomplete-search
                model="users"
                [inputItems]="transferDropDown.users"
                [pagination]="paginationData.users"
                bindLabel="employeeAlias"
                id="employeeId"
                label="Responsible Party"
                dropdownType="single"
                #usersAutocomplete
                (filter)="fillJobsData($event)">
              </app-tool-transfer-autocomplete-search>
            </div>
          </div>
        </div>

        <!-- Assigned to Shop -->
        <div *ngIf="assignmentGroup === assignmentGroupsType.AssignedToShop" class="field-group">
          <div class="row">
            <div class="col-12">
              <label> Shop </label>
              <app-tool-transfer-autocomplete-search
                model="shops"
                [inputItems]="transferDropDown.shops"
                [pagination]="paginationData.shops"
                bindLabel="name"
                id="shopId"
                label="Shop"
                dropdownType="single"
                #shopsAutocomplete
                (filter)="fillJobsData($event)">
              </app-tool-transfer-autocomplete-search>
            </div>
          </div>
        </div>

        <!-- Out for Repair -->
        <div *ngIf="assignmentGroup === assignmentGroupsType.OutForRepair" class="field-group">
          <div class="row">
            <div class="col-12">
              <label> Vendor </label>
              <app-tool-transfer-autocomplete-search
                model="vendors"
                [inputItems]="transferDropDown.vendors"
                [pagination]="paginationData.vendors"
                bindLabel="companyName"
                id="vendorId"
                label="Vendor"
                dropdownType="single"
                #vendorsAutocomplete
                (filter)="fillJobsData($event)">
              </app-tool-transfer-autocomplete-search>
            </div>
          </div>
        </div>

        <!-- Other -->
        <div *ngIf="assignmentGroup === assignmentGroupsType.Other" class="field-group">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="other">Other</label>
                <select id="other" class="form-control" (change)="selectAssignmentType($event)" required>
                  <option value="" selected>Select other</option>
                  <option *ngFor="let assignmentType of assignmentTypes" [value]="assignmentType.id">
                    {{ assignmentType.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="assignmentGroup" class="card">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label>Transfer Notes</label>
            <textarea
              class="form-control"
              rows="5"
              placeholder="Add notes to give context to transfer"
              (keyup)="addTransferNotes($event)"></textarea>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label>Transfer Date</label>
            <input
              class="form-control datepicker"
              type="date"
              [(ngModel)]="assignedDate"
              [min]="previousDate()"
              (change)="handleAssignedDate($event)"
              required />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button class="btn btn-outline-primary" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="handleTransfer('transfer')">Transfer</button>
    <button class="btn btn-primary" (click)="handleTransfer('close')">Transfer & Close</button>
  </div>
</div>
